import React from "react";
import { motion } from "framer-motion";

const Mining = () => {
  return (
    <section
      id="mining"
      className="py-12 px-4 bg-cover bg-center relative"
    >
      <div className="absolute inset-0 bg-black bg-opacity-80"></div>

      <div className="relative max-w-6xl mx-auto mb-8">
        <motion.h2
          className="text-3xl font-bold text-red-600 mb-6 text-center border-b-4 border-yellow-400 inline-block"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Mining in Menelik
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <p className="text-gray-200">
              Menelik features mining capabilities powered by the{" "}
              <strong className="text-yellow-400">GhostRider</strong> algorithm, enabling{" "}
              <strong className="text-red-400">efficient CPU/GPU mining</strong>. Our goal is to make mining
              accessible and fair for all users, ensuring a just and rewarding process.
            </p>
            <p className="mt-4 text-gray-200">
              <strong className="text-yellow-400">75% of the block reward (3,750 MENEL)</strong> is allocated to
              miners, ensuring network security and continuous participation.
            </p>
          </motion.div>
          <motion.div
            className="bg-black bg-opacity-50 p-6 rounded-lg shadow-md backdrop-blur-md border-l-4 border-red-600"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h3 className="font-semibold text-xl mb-2 text-yellow-400">Why GhostRider?</h3>
            <ul className="list-disc ml-4 text-gray-200">
              <li>ASIC resistance to promote decentralization.</li>
              <li>Respectful of the planet, since it uses simple processors.</li>
              <li>More accessible mining for users without specialized hardware.</li>
              <li>Fair distribution of rewards.</li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Mining;
